// @ts-nocheck
import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { errorMessages } from '../utilities/error-messages';

export interface NewFormInputInterface {
  label: string;
  placeholder?: string;
  type: string;
  name: string;
  menu?: string[];
  optional?: boolean;
}

@Injectable({ providedIn: 'root' })
export class FormService {
  getFieldErrorMessage(
    form: FormGroup,
    fieldName: string,
    customName: string = ''
  ) {
    const hasError = form.get(fieldName)?.errors;
    const errorType = hasError ? Object.keys(hasError)[0] : '';
    const formattedFieldName =
      customName ||
      `${fieldName[0].toUpperCase()}${fieldName.replace(/[_.]/, ' ').slice(1)}`;

    if (
      (fieldName === 'phone' || fieldName === 'legal_phone') &&
      form.controls[fieldName]?.controls
    ) {
      if (!form.controls[fieldName]?.controls?.phoneNumber.value) {
        return;
      }
    } else if (
      !form.controls[fieldName]?.touched &&
      !form.controls[fieldName]?.value
    )
      return;

    if (formattedFieldName === 'Password') {
      console.log(form.get(fieldName));
    }

    if (hasError) {
      switch (errorType) {
        case 'phoneNumberError':
          return errorMessages['phoneNumberError'].replace(
            '{field}',
            formattedFieldName
          );
        case 'required':
          return errorMessages['required'].replace(
            '{field}',
            formattedFieldName
          );
        case 'notUnique':
          return errorMessages['notUnique'].replace(
            '{field}',
            formattedFieldName
          );
        case 'minlength': {
          const {
            minlength: { requiredLength, actualLength },
          } = hasError;
          const toReplace = {
            '{field}': formattedFieldName,
            '{requiredLength}': requiredLength,
            '{actualLength}': actualLength,
          };

          return errorMessages['minlength'].replace(
            /{field}|{requiredLength}|{actualLength}/g,
            (m) => {
              return toReplace[m];
            }
          );
        }

        case 'maxlength': {
          const {
            maxlength: { requiredLength },
          } = hasError;
          const toReplace = {
            '{field}': formattedFieldName,
            '{requiredLength}': requiredLength,
          };

          return errorMessages['maxlength'].replace(
            /{field}|{requiredLength}/g,
            (m) => {
              return toReplace[m];
            }
          );
        }
        case 'min': {
          const { min: minErr } = hasError;
          return errorMessages['min'].replace('{value}', minErr?.['min']);
        }

        case 'max': {
          const { max: maxErr } = hasError;
          return errorMessages['max'].replace(
            '{value}',
            maxErr['max'].toLocaleString()
          );
        }

        case 'pattern':
          return errorMessages[
            form.get(fieldName).errors['pattern']['requiredPattern']
          ];

        case 'invalidEmail':
          return 'Invalid email format';

        case 'serverError':
          return form.get(fieldName)?.errors.serverError[0];

        default:
          return errorMessages[Object.keys(form.get(fieldName).errors)[0]];
      }
    }
  }

  hasError(form: FormGroup, fieldName: string): boolean {
    return form.get(fieldName).touched && form.get(fieldName)?.errors;
  }

  getFieldValidation(form: FormGroup, fieldName: string): boolean {
    return !form.get(fieldName).valid && form.get(fieldName).touched;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);

      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  phoneFieldErrorMessage(form) {
    const {
      phone: { countryCode, phoneNumber },
    } = form.value;

    //  only return the validation for the group if the countryCode is available
    if (countryCode && phoneNumber) {
      if (this.getFieldValidation(form, 'phone')) {
        return this.getFieldErrorMessage(form, 'phone');
      }
    }

    if (this.getFieldValidation(form, 'phone.phoneNumber')) {
      return this.getFieldErrorMessage(form, 'phone.phoneNumber', 'Phone');
    }

    return null;
  }

  containsNumbers(str: string) {
    return /\d/.test(str);
  }

  containsSpecialChars(str: string) {
    const specialChars = /[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
    return specialChars.test(str);
  }

  containsUppercase(str: string) {
    return /[A-Z]/.test(str);
  }

  isValidEmail(email: string): boolean {
    const regex =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/i;
    return regex.test(email);
  }

  mapErrorToForm(form: FormGroup, error: any) {
    for (let key in error) {
      if (form?.controls[key]) {
        form.controls[key].markAllAsTouched();
        form.controls[key].markAsDirty();
        form.controls[key].setErrors({
          notUnique: error[key],
        });
      }
    }
  }
}
